export default {
  pageDescription: {
    id: 'eligible_insurance_page_description',
    defaultMessage:
      'Your devices aren’t protected yet, but there’s still time. Select one of your devices to see what plans are available.',
  },
  eligibleDevices: {
    id: 'policies_and_eligible_insurances_eligible_devices',
    defaultMessage: 'Eligible devices',
  },
  repairTitle: {
    id: 'eligible_insurance_page_repair_title',
    defaultMessage: 'On demand repair',
  },
}
